import { render, staticRenderFns } from "./GetResidentsForCooperationSystem.vue?vue&type=template&id=59c28b54&scoped=true&lang=pug"
import script from "./GetResidentsForCooperationSystem.vue?vue&type=script&lang=ts"
export * from "./GetResidentsForCooperationSystem.vue?vue&type=script&lang=ts"
import style0 from "./GetResidentsForCooperationSystem.vue?vue&type=style&index=0&id=59c28b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c28b54",
  null
  
)

export default component.exports